const feedTypes = {
  FETCH_POSTS_START: 'FETCH_POSTS',
  FETCH_POSTS_FAILURE: 'FETCH_POSTS_FAILURE',
  FETCH_POSTS_SUCCESS: 'FETCH_POSTS_SUCCESS',
  ADD_POST: 'ADD_POST',
  REMOVE_POST: 'REMOVE_POST',
  CLEAR_POSTS: 'CLEAR_POSTS',
};

export default feedTypes;
